import React from "react";
import Listv4 from "../List/ListV4";
import "./Partner.css";

const Partner = () => {
  const eventList4 = [
    {
      title: "MewMovement",
      desc: "Charismatic indie art store at SS2, est. in March 2021. Unites people through art, a haven for self-expression.",
    },
    {
      title: "Saltyeeth",
      desc: "Meet Elena Laurel, the certified Tooth Gem artist since 2021. Leading Malaysia's tooth gem scene, inspiring creativity.",
    },
    {
      title: "Flower Bar",
      desc: "Discover Shanice, the talented florist since 2020. Crafting stunning bouquets, she elevates events with her artistry.",
    },
    {
      title: "Dakwat KL Tattoo",
      desc: "Embrace airbrushed temporary tattoos. Unleash your artistic spirit without the burdens of permanence and expense.",
    },
    {
      title: "Evah Henna Art Studio",
      desc: "Artistic henna body art studio, est. in 2016. Explore both traditional and contemporary, and customised henna body art.",
    }
  ];
  
  return (
    <div className="pt-40 container mx-auto h-full relative event-parent partner-container">
      <div
        className="content-aside-container text-white"
        id="specialAppearance"
      >
        <h3 className="star-partner-hd mb-7  text-2xl event-list-hd title">
          More Than Just Music Partners
        </h3>
      </div>
      <Listv4 event={eventList4} />
    </div>
  );
};

export default Partner;
